import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFeaturesBackground = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 1280, height: 448, viewBox: "0 0 1280 448", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M692.421 208.5C505.669 208.5 455.5 27 232.765 27C127.572 27 55.1863 47.0232 0 69.6706V449H1280V0H1276.22C1055.76 0 895.761 208.5 692.421 208.5Z", fill: "#DC7D11", fillOpacity: 0.2 }));
const ForwardRef = forwardRef(SvgFeaturesBackground);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
